import { useState } from "react";
import { useDispatch } from "react-redux";

import actions from "@/actions";
import { GetTaskCommentsResult } from "@/components/comment/actions/types";
import { Comment } from "@/models/comments";
import { TaskComment } from "@/models/tasks";

export const useCommentListModal = () => {
  const dispatch = useDispatch();

  const [comments, setComments] = useState<TaskComment[]>([]);
  const [itemName, setItemName] = useState("");
  const [processName, setProcessName] = useState("");
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const open = (item: Pick<Comment, "task_id" | "item_name" | "process_name">) => {
    dispatch(
      actions.comment.getTaskComments({ task_id: item.task_id }, (res: GetTaskCommentsResult) => {
        setComments(res.list);
        setItemName(item.item_name);
        setProcessName(item.process_name);
        setIsOpen(true);
      })
    );
  };

  const close = () => {
    setIsOpen(false);
    setComments([]);
    setItemName("");
    setProcessName("");
  };

  return {
    isOpen,
    open,
    close,
    comments,
    itemName,
    processName,
  };
};
